import React, { createRef, useEffect, useState } from "react";
import { gsap } from "gsap";

import "./Download.css";
import HeaderBar from "../../components/HeaderBar";

import Telegram from "./../../assets/icons/telegram.png";

const Download = () => {
  const rightIllusRef = createRef();
  const leftIllusRef = createRef();

  useEffect(() => {
    gsap.to(rightIllusRef.current, {
      x: 0,
      opacity: 1,
      duration: 2,
      ease: "ease-in-out",
    });
    gsap.to(leftIllusRef.current, {
      x: 0,
      opacity: 1,
      duration: 2,
      ease: "ease-in-out",
    });
  }, []);

  return (
    <div className="outerContainer">
      <div className="container">
        <HeaderBar delay={0.5} />

        <div className="downloadDisplay">
          <div className="downloadCardContainer">
            <div className="downloadHeader">mobile app</div>
            <div className="downloadArea downloadAreaLeft">
              <img
                ref={leftIllusRef}
                src="/illus.svg"
                className="downloadIllus leftDownloadIllus"
                alt="image"
              />
              <div className="downloadDetails leftDownloadDetails">
                <div className="downloadDetailsPoints">
                  Get instant results right from your device. And easily can
                  find past results!
                </div>

                <div className="downloadDetailsPointsFooter">Download Now</div>
              </div>
            </div>
          </div>

          <div className="downloadCardContainer">
            <div className="downloadHeader">web app</div>
            <div className="downloadArea downloadAreaRight">
              <img
                ref={rightIllusRef}
                src="/webapp.svg"
                className="downloadIllus rightDownloadIllus"
                alt="image"
              />
              <div className="downloadDetails rightDownloadDetails">
                <div className="downloadDetailsPoints">
                  Having lower version of android devices?
                </div>

                <div className="downloadDetailsPoints">
                  Use the fastest lite version of our web.
                </div>

                <div className="downloadDetailsPointsFooter">Learn how!</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;
